import React from "react";
import bigleft from "../../assets/Iphone/Types_of_IOS/Info.svg";
import native from "../../assets/Iphone/Types_of_IOS/Native.svg";
import hybrid from "../../assets/Iphone/Types_of_IOS/Hybrid.svg";

const CoreComponent5 = () => {
  return (
    <div className="row d-flex">
      <div className="col-md-6 mx-auto">
        <img src={bigleft} alt="" className="mx-ato mx-0" />
      </div>
      <div className=" col-md-6">
        <div
          className=" p-3 ms-2 ms-md-0 position-relative rounded-2  mb-2 "
          style={{ border: "1px dashed #bfbfbf",height: "48%" }}
        >
          <span
            className="position-absolute  img-left-border"
            style={{ border: "1px dashed #bfbfbf" }}
          >
            <img src={native} className=" m-0" alt="" />
          </span>
          <h3 className="h3-heading text-start fs-5 ps-4 mb-2">Native App Development</h3>
          <p className="h1-para fs-6 lh-sm ps-4">
            Strategic monetization techniques embedded in our iOS development
            processes transform app experiences into substantial revenue streams
            while enhancing brand market value.
          </p>
        </div>
        <div
          className="ms-2 ms-md-0 p-3 position-relative rounded-2"
          style={{ border: "1px dashed #bfbfbf", height: "48%" }}
        >
          <div className="position-absolute  img-left-border">
            <img src={hybrid} className="m-0" alt="" />
          </div>
          <h3 className="h3-heading text-start fs-5 ps-4 mb-2">Hybrid App Development</h3>
          <p className="h1-para  fs-6 lh-sm ps-4">
            Our hybrid approach delivers cost-effective iOS apps with wider
            reach. We build versatile applications from a single codebase,
            ensuring consistent functionality and faster deployment for a
            client's diverse user base.
          </p>
        </div>
      </div>
    </div>
  );
};

export default CoreComponent5;
